import { City } from '../types/city';

export const cities: City[] = [
  {
    name: 'Ottawa',
    lat: 45.424721,
    lon: -75.695,
  },
  {
    name: 'Moscow',
    lat: 55.751244,
    lon: 37.618423,
  },
  {
    name: 'Tokyo',
    lat: 35.672855,
    lon: 139.817413,
  },
];
